import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.125 18a.375.375 0 1 0 0 .75h3.75a.375.375 0 0 0 0-.75h-3.75ZM7.687 1.5A2.437 2.437 0 0 0 5.25 3.938v16.125A2.437 2.437 0 0 0 7.688 22.5h8.625a2.438 2.438 0 0 0 2.437-2.438V3.938A2.438 2.438 0 0 0 16.312 1.5H7.688ZM6 3.938A1.687 1.687 0 0 1 7.688 2.25h8.625A1.687 1.687 0 0 1 18 3.938v16.125a1.687 1.687 0 0 1-1.688 1.687H7.688A1.687 1.687 0 0 1 6 20.062V3.938Z",
  fill: "#101010"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }